import { render, staticRenderFns } from "./authorization2.vue?vue&type=template&id=61a0ab09&scoped=true&"
import script from "./authorization2.vue?vue&type=script&lang=js&"
export * from "./authorization2.vue?vue&type=script&lang=js&"
import style0 from "./authorization2.vue?vue&type=style&index=0&id=61a0ab09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a0ab09",
  null
  
)

export default component.exports